import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Copy, Check } from 'lucide-react';
export function EmbedCodes() {
  const {
    id
  } = useParams();
  const [copied, setCopied] = useState<string | null>(null);
  const handleCopy = (type: string, text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(type);
    setTimeout(() => setCopied(null), 2000);
  };
  const scriptCode = `<div id="form-container-${id}"></div>
<script src="https://api.example.com/embed/v1/forms/${id}.js" async></script>`;
  const iframeCode = `<iframe 
  src="https://api.example.com/embed/v1/forms/${id}/view" 
  width="100%" 
  height="500" 
  frameborder="0"
></iframe>`;
  return <div className="space-y-6" data-id="element-1092">
      <div className="flex items-center gap-4" data-id="element-1093">
        <Link to="/forms" className="p-2 hover:bg-gray-100 rounded-full text-gray-500" data-id="element-1094">
          <ArrowLeft className="h-5 w-5" data-id="element-1095" />
        </Link>
        <div data-id="element-1096">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1097">Embed Codes</h1>
          <p className="text-sm text-gray-500" data-id="element-1098">
            Choose an integration method for your website.
          </p>
        </div>
      </div>

      <div className="grid gap-6" data-id="element-1099">
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1100">
          <div className="flex items-center justify-between mb-4" data-id="element-1101">
            <div data-id="element-1102">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-1103">
                JavaScript Embed (Recommended)
              </h3>
              <p className="text-sm text-gray-500" data-id="element-1104">
                Injects the form directly into your page. Inherits your site's
                styles better.
              </p>
            </div>
            <button onClick={() => handleCopy('script', scriptCode)} className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors" data-id="element-1105">
              {copied === 'script' ? <Check className="h-4 w-4" data-id="element-1106" /> : <Copy className="h-4 w-4" data-id="element-1107" />}
              {copied === 'script' ? 'Copied!' : 'Copy Code'}
            </button>
          </div>
          <div className="bg-gray-900 rounded-md p-4 overflow-x-auto" data-id="element-1108">
            <pre className="text-sm text-gray-100 font-mono" data-id="element-1109">{scriptCode}</pre>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1110">
          <div className="flex items-center justify-between mb-4" data-id="element-1111">
            <div data-id="element-1112">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-1113">
                Iframe Embed
              </h3>
              <p className="text-sm text-gray-500" data-id="element-1114">
                Isolates the form styles completely. Good for conflicts.
              </p>
            </div>
            <button onClick={() => handleCopy('iframe', iframeCode)} className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors" data-id="element-1115">
              {copied === 'iframe' ? <Check className="h-4 w-4" data-id="element-1116" /> : <Copy className="h-4 w-4" data-id="element-1117" />}
              {copied === 'iframe' ? 'Copied!' : 'Copy Code'}
            </button>
          </div>
          <div className="bg-gray-900 rounded-md p-4 overflow-x-auto" data-id="element-1118">
            <pre className="text-sm text-gray-100 font-mono" data-id="element-1119">{iframeCode}</pre>
          </div>
        </div>
      </div>
    </div>;
}